// extracted by mini-css-extract-plugin
module.exports = {"tagsTable":"_1DrF6S_t","tagsTableEmptyMessage":"_1xV0oco5"};